<h2 class="dialog-title">
  <ng-content></ng-content>
</h2>
